<template>
  <v-row justify="start">
    <v-dialog
      v-model="dialogErr"
      @click:outside="$emit('close')"
      scrollable
      max-width="500px"
    >
      <v-card class="rounded-max">
        <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <div class="d-flex justify-center mb-3">
              <img
                src="../../../assets/img/Popup Alert-Wrong0.png"
                height="75px"
                alt=""
              />
            </div>
            <h3 v-if="txt" class="text-center">Terjadi Kesalahan.</h3>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" color="red" text>ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "selectJourney",

  props: ["dialogErr", "txt"],
};
</script>
<style scoped>
.no_decoration {
  text-decoration: none;
}
.img-journey {
  height: 50px;
  /* width: 60px;
  object-fit: cover; */
}
.rounded-img {
  height: 75px;
  width: 75px;
  background: white;
  border-radius: 50%;
}
.decoration {
  text-decoration: none;
}
</style>
